import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export interface TemplateVersion {
  id: string;
  template_id: string;
  version_number: number;
  is_current: boolean;
  published_at: string;
  published_by_user_id: string | null;
  created_at: string;
}

export function useTemplateVersions(templateId: string | undefined) {
  return useQuery<TemplateVersion[]>({
    queryKey: ['template-versions', templateId],
    enabled: !!templateId,
    queryFn: async () => {
      const { data } = await apiClient.get<{ data: TemplateVersion[]; meta: { count: number } }>(
        `/assessment-templates/${templateId}/versions`,
      );
      return data.data;
    },
    staleTime: 30_000,
  });
}
